export default function(data) {
  this.dummyBool = ko.observable(true); //used to force computed observable to update

  this.availableFeatures = ko.observableArray([
    'shared_transcode',
    'polycom',
    'shop',
    'unplag',
    'lti',
    'salesforce',
  ]);

  this.sso_types = ko.observableArray(['none', 'ldap', 'shibboleth']);

  this.institution = ko.observable();

  this.featureLabel = key => I18n.t('admin.institutions.features.' + key)

  this.save = isAutosave => {
    const request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.admin_institution_path(this.institution().id()),
      type: 'PATCH',
      data: { institution: ko.mapping.toJS(this.institution) },
      dataAsJSON: true,
      loadingIndicator: {}
    });

    request.done(() => {
      // write the json to handle back button issues
      const obj = { institution: ko.mapping.toJS(this.institution) };
      $('#settings_json').val(JSON.stringify(obj));
      new Kadenze.Notice.success({ message: 'Saved Successfully' });
    });

    request.fail(xhr => {
      const message = xhr.responseJSON ?
        xhr.responseJSON.errors :
        I18n.t('notice.unexpected_error');
      new Kadenze.Notice.error({ message });
    });
  };

  this.bindData = data => {
    this.institution = ko.observable(ko.mapping.fromJS(data.institution));

    if (this.institution().settings.features == null)
      this.institution().settings.features = {};

    if (!this.institution().settings.features.disabled)
      this.institution().settings.features.disabled = ko.observableArray([]);

    if (!this.institution().settings.features.enabled)
      this.institution().settings.features.enabled = ko.observableArray([]);
  };

  (() => {
    this.bindData(data);

    this.institution().settings.features.enabled.subscribe(changes => {
      changes.forEach(ele => {
        if (ele.status == 'deleted') {
          this.institution().settings.features.disabled.push(ele.value);
        } else {
          this.institution().settings.features.disabled.remove(ele.value);
        }
      });
    }, null, 'arrayChange');

    setTimeout(() => new Kadenze.KdForms().update(), 200);
  })()
}
